import React, { useEffect } from 'react';

function AnchorInternal({ link, path, component, register, unregister, update, wrapperStyle = null }) {
  useEffect(() => {
    register({
      link,
      path,
      component,
      wrapperStyle,
    });
    return () => {
      unregister({
        link,
        path,
        component,
        wrapperStyle,
      });
    };
  }, []);

  useEffect(() => {
    if (component) {
      update({
        link,
        path,
        component,
        wrapperStyle,
      });
    }
  }, [component]);

  return null;
}

const BreadcrumbsAnchor = ({ context, ...props }) => {
  const { Consumer } = context;
  return (
    <Consumer>
      {(value) => (
        // @ts-expect-error - Type '{ register: any; unregister: any; update: any; }' is missing the following properties from type '{ link: any; path: any; component: any; register: any; unregister: any; update: any; wrapperStyle?: null | undefined; }': link, path, component
        <AnchorInternal register={value.register} unregister={value.unregister} update={value.update} {...props} />
      )}
    </Consumer>
  );
};

// BreadcrumbsAnchor.propTypes = {
//   context: PropTypes.shape({
//     Provider: PropTypes.object.isRequired,
//     Consumer: PropTypes.object.isRequired,
//   }).isRequired,
// };

export default BreadcrumbsAnchor;
